// The names existing app data already carries (ADR 0058 §7.3, Board #2718). Releases before the app's names were plain
// wrote them into databases, browsers and contracts; the app adopts them as they are, so no deployment's data, sign-in
// or contract has to move. This module is the only place they are spelled (the concept guard,
// tools/scripts/check-app-concepts.test.mjs, holds every other file of a project's app to that); a new app's own names
// are plain.

/** The prefix earlier releases gave a data schema (`proto_<name>`); its schemas and role beside it are `<kind>_<name>`. */
const EARLIER_DATA_SCHEMA_PREFIX = 'proto_';

/** The part of a data schema's name its governed schema, context schema and runtime role are named after. */
export const dataSchemaStem = (schema: string): string =>
  schema.startsWith(EARLIER_DATA_SCHEMA_PREFIX) ? schema.slice(EARLIER_DATA_SCHEMA_PREFIX.length) : schema;

/** The database of the apps' own data on a server when the runtime is given none (an existing deployment's). */
export const DEFAULT_DATA_DATABASE = 'cortex_prototype';

/**
 * The schema of the runtime's caller context in the data database: the caller rows and the functions every app's
 * row-level security policies name (existing policies name them by this schema).
 */
export const CALLER_SCHEMA = 'cortex';

/** The session setting that points a statement at its caller row. */
export const CALLER_SETTING = 'cortex.ctx';

/** The prefix of the role that writes the caller rows (one per data database and role secret). */
export const CALLER_ROLE_PREFIX = 'cortex_ctx_';

/** The extension of an app's contract that declares its tenancy (apps' contracts carry it). */
export const TENANCY_MARK = 'x-cortex-tenancy';

/** The app runtime's session cookie (browsers hold it). */
export const SESSION_COOKIE = 'cortex_proto_session';

/** The advisory lock key of applying a data schema's rows (every runtime on a server takes the same one). */
export const APPLY_LOCK = 'cortex:prototype-apply';

/** The advisory lock key of the data database's grants. */
export const ACL_LOCK = 'cortex:prototype-database-acl';

/** The table of rule outcomes in an app's data (ADR 0027). */
export const OUTCOME_TABLE = 'cortex_rule_outcome';

// The names apps' own code and contracts read on the wire (their handlers, their pages, their openapi.json).

/** The header that says what called an app's operation: `app`, `agent`, `workflow` (a hint, never proof). */
export const CALLER_HEADER = 'x-cortex-caller';
/** The header that names the app (`<instance>/<app>`) an app-to-app call comes from. */
export const CALLING_APP_HEADER = 'x-cortex-calling-app';
/** The headers that name the workflow run and step an operation is called for. */
export const WORKFLOW_RUN_HEADER = 'x-cortex-workflow-run';
export const WORKFLOW_STEP_HEADER = 'x-cortex-workflow-step';
/** The header the runtime itself sets on a call of a run an app key started (dropped from every client request). */
export const RUN_STARTER_HEADER = 'x-cortex-run-starter';
/** The prefix of the headers above: a key call's handler sees none of a client's. */
export const RUNTIME_HEADER_PREFIX = 'x-cortex-';
/** The openapi mark of an operation the app's own API keys may call. */
export const APP_KEY_MARK = 'x-cortex-app-key';
/** The openapi mark of a read an app's own host records (Doc2Data's contract carries it since 2026-10-30). */
export const AUDIT_MARK = 'x-cortex-audit';
/** The header an app's chat names its app with. */
export const APP_REACH_HEADER = 'x-cortex-app';
/** The global the app's page reads what its server says of it from (`window.<name>`). */
export const PAGE_INFO_GLOBAL = '__CORTEX_APP__';
